export default __webpack_public_path__ + "static/media/banner-inner2.bc4442ce.jpg";